import { useState, type KeyboardEvent } from 'react';
import { useChatColors } from '@/contexts/ChatColorsContext';

interface ChatInputProps {
  disabled: boolean;
  onSend: (text: string) => void;
}

export default function ChatInput({ disabled, onSend }: ChatInputProps) {
  const [value, setValue] = useState('');
  const { primary } = useChatColors();

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="flex items-center gap-2 px-3 py-3 bg-white border-t border-gray-100 flex-shrink-0">
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder={disabled ? 'Selecione uma opção acima...' : 'Digite sua mensagem...'}
        className="flex-1 bg-gray-50 border border-gray-200 rounded-full px-4 py-2 text-sm text-gray-700 placeholder-gray-400 outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ ['--tw-ring-color' as string]: `${primary}33` }}
        onFocus={(e) => { e.currentTarget.style.borderColor = primary; }}
        onBlur={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
      />
      <button
        type="button"
        onClick={handleSend}
        disabled={disabled || !value.trim()}
        className="w-10 h-10 flex items-center justify-center rounded-full text-white shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed hover:scale-105 active:scale-95 cursor-pointer flex-shrink-0"
        style={{ background: `linear-gradient(135deg, ${primary}cc, ${primary})` }}
      >
        <i className="ri-send-plane-fill text-base" />
      </button>
    </div>
  );
}
